import { createSlice } from "@reduxjs/toolkit";
import {
  createFraseThunk,
  getFraseByIdThunk,
  getFrasesThunk,
  toggleFraseActiveThunk,
  updateFraseThunk,
} from "./frases.thunks";

const initialState = {
  list: [],
  loading: false,
  error: null,
  page: 1,
  pageSize: 10,
  totalPages: 1,
  count: 0,
  next: null,
  previous: null,
  maxPageReached: 1,
  search: "",
  talentoFilter: "",
  isRandomFilter: "",

  selectedFrase: null,
  selectedFraseLoading: false,
  selectedFraseError: null,
  viewModalOpen: false,

  formModalOpen: false,
  formMode: "create", // "create" | "edit"
  formLoading: false,
  formError: null,

  confirmModalOpen: false,
  toggleFraseId: null,
  toggling: false,
};

const frasesSlice = createSlice({
  name: "frases",
  initialState,
  reducers: {
    clearFrasesError: (state) => {
      state.error = null;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      state.page = 1; // Reset a página 1 al buscar
    },
    setTalentoFilter: (state, action) => {
      state.talentoFilter = action.payload;
      state.page = 1;
    },
    setIsRandomFilter: (state, action) => {
      state.isRandomFilter = action.payload;
      state.page = 1;
    },
    clearFilters: (state) => {
      state.search = "";
      state.talentoFilter = "";
      state.isRandomFilter = "";
      state.page = 1;
    },
    openViewModal: (state) => {
      state.viewModalOpen = true;
    },
    closeViewModal: (state) => {
      state.viewModalOpen = false;
      state.selectedFrase = null;
    },
    openFormModal: (state, action) => {
      state.formModalOpen = true;
      state.formMode = action.payload?.mode || "create";
      if (action.payload?.frase) {
        state.selectedFrase = action.payload.frase;
      }
      state.formError = null;
    },
    closeFormModal: (state) => {
      state.formModalOpen = false;
      state.selectedFrase = null;
      state.formError = null;
    },
    openConfirmToggle: (state, action) => {
      state.confirmModalOpen = true;
      state.toggleFraseId = action.payload.id;
    },
    closeConfirmToggle: (state) => {
      state.confirmModalOpen = false;
      state.toggleFraseId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET ALL
      .addCase(getFrasesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFrasesThunk.fulfilled, (state, action) => {
        const { results, count, next, previous } = action.payload;

        state.loading = false;
        state.list = results;
        state.count = count;
        state.next = next;
        state.previous = previous;

        state.maxPageReached = Math.max(state.maxPageReached, state.page);
      })
      .addCase(getFrasesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // GET BY ID
      .addCase(getFraseByIdThunk.pending, (state) => {
        state.selectedFraseLoading = true;
        state.selectedFraseError = null;
      })
      .addCase(getFraseByIdThunk.fulfilled, (state, action) => {
        state.selectedFraseLoading = false;
        state.selectedFrase = action.payload;
      })
      .addCase(getFraseByIdThunk.rejected, (state, action) => {
        state.selectedFraseLoading = false;
        state.selectedFraseError = action.payload;
      })

      // CREATE
      .addCase(createFraseThunk.pending, (state) => {
        state.formLoading = true;
        state.formError = null;
      })
      .addCase(createFraseThunk.fulfilled, (state) => {
        state.formLoading = false;
        state.formModalOpen = false;
        state.selectedFrase = null;
      })
      .addCase(createFraseThunk.rejected, (state, action) => {
        state.formLoading = false;
        state.formError = action.payload;
      })

      // UPDATE
      .addCase(updateFraseThunk.pending, (state) => {
        state.formLoading = true;
        state.formError = null;
      })
      .addCase(updateFraseThunk.fulfilled, (state) => {
        state.formLoading = false;
        state.formModalOpen = false;
        state.selectedFrase = null;
      })
      .addCase(updateFraseThunk.rejected, (state, action) => {
        state.formLoading = false;
        state.formError = action.payload;
      })

      // TOGGLE ACTIVE
      .addCase(toggleFraseActiveThunk.pending, (state) => {
        state.toggling = true;
      })
      .addCase(toggleFraseActiveThunk.fulfilled, (state) => {
        state.toggling = false;
        state.confirmModalOpen = false;
        state.toggleFraseId = null;
      })
      .addCase(toggleFraseActiveThunk.rejected, (state, action) => {
        state.toggling = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearFrasesError,
  setPage,
  setSearch,
  setTalentoFilter,
  setIsRandomFilter,
  clearFilters,
  openViewModal,
  closeViewModal,
  openFormModal,
  closeFormModal,
  openConfirmToggle,
  closeConfirmToggle,
} = frasesSlice.actions;

export default frasesSlice.reducer;
